export const getTruncatedModuleNames = (item: any, maxLength: number) => {
  const moduleNames: string[] = [];

  item.permissions.forEach((permission: any) => {
    if (permission.module?.name && permission.is_active) {
      const fullName = permission.module.description;
      const truncatedName = fullName.length > maxLength
        ? fullName.slice(0, maxLength) + '...'
        : fullName;

      moduleNames.push(truncatedName);
    }
  });

  return moduleNames;
};
